import React from 'react';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { tutorStepPropTypes } from './step-component-props';
import { LearnMore } from './learn-more';
import helpValidationImage from '../../media/helpValidation.png';
import { StyledTutorialStep } from './tutorial-steps';

export const ValidateYourUETTag = (props) => {
  const { i18n } = props;
  const edgeExtURL = 'https://microsoftedge.microsoft.com/addons/detail/uet-tag-helper-by-micros/nmcihgehpmokipeigjpeckphhdejjpbf';
  const chromeExtURL = 'https://chrome.google.com/webstore/detail/uet-tag-helper-by-bing-ad/naijndjklgmffmpembnkfbcjbognokbf';
  const tutorTemplate = i18n.getString(_TL_('It can take up to 24 hours for us to verify your UET tags. In the meantime, you can check your UET tag status status and test whether your conversion goals are set up correctly using the UET tag helper browser extension. You can install the extension on {{m}}Microsoft Edge{{/m}} or {{g}}Google Chrome{{/g}}.'));
  const helpLabel = i18n.getString(_TL_('It can take up to 24 hours for us to verify your UET tags. In the meantime, you can check your UET tag status status and test whether your conversion goals are set up correctly using the UET tag helper browser extension. You can install the extension on Microsoft Edge or Google Chrome.'));
  const content = (
    <p>
      <ReactTemplate
        model={{
          m: text => (<a href={edgeExtURL} aria-label={text} target="_blank" rel="noopener noreferrer">{text}</a>),
          g: text => (<a href={chromeExtURL} aria-label={text} target="_blank" rel="noopener noreferrer">{text}</a>),
        }}
        template={tutorTemplate}
      />
      <LearnMore i18n={i18n} topicId="app54548" ariaLabel={helpLabel} />
    </p>
  );

  return (
    <StyledTutorialStep
      title={i18n.getString(_TL_('Validate your UET tag'))}
      descTemp={content}
      imageSrc={helpValidationImage}
      i18n={i18n}
    />
  );
};

ValidateYourUETTag.propTypes = tutorStepPropTypes;
